/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { DeepAnalysisControllerExecuteMutationRequest, DeepAnalysisControllerExecuteMutationResponse, DeepAnalysisControllerExecutePathParams, DeepAnalysisControllerExecute400, DeepAnalysisControllerExecute401, DeepAnalysisControllerExecute403 } from "../../models/aiAgentV2Controller/DeepAnalysisControllerExecute";

function getDeepAnalysisControllerExecuteUrl(sessionId: DeepAnalysisControllerExecutePathParams["sessionId"]) {
  const res = { method: 'POST', url: `/api/v1/ai-agent-v2/deep-analysis/${sessionId}/execute` as const }  
  return res
}

/**
 * @summary Execute deep analysis session
 * {@link /api/v1/ai-agent-v2/deep-analysis/:sessionId/execute}
 */
export async function deepAnalysisControllerExecute(sessionId: DeepAnalysisControllerExecutePathParams["sessionId"], data?: DeepAnalysisControllerExecuteMutationRequest, config: Partial<RequestConfig<DeepAnalysisControllerExecuteMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = data  
  
  const res = await request<DeepAnalysisControllerExecuteMutationResponse, ResponseErrorConfig<DeepAnalysisControllerExecute400 | DeepAnalysisControllerExecute401 | DeepAnalysisControllerExecute403>, DeepAnalysisControllerExecuteMutationRequest>({ method : "POST", url : getDeepAnalysisControllerExecuteUrl(sessionId).url.toString(), data : requestData, ... requestConfig, headers : { 'Content-Type': 'application/vnd.api+json', ...requestConfig.headers } })  
  return res.data
}